import { FC } from 'react'
import styles from './LeftContents.module.scss'
import { LeftContentDataType } from '../types/types'

type leftContentDataProps = {
  isSecondContent: boolean
  leftContentData: LeftContentDataType
}

const LeftContents: FC<leftContentDataProps> = ({ leftContentData, isSecondContent }) => {
  return (
    <div className={styles.left_content}>
      <div className={styles.inner_content}>
      <figure className={leftContentData.imgBorder === 'true' ? styles.imgBorder : undefined}>
        <img src={leftContentData.imgLarge} alt={leftContentData.alt} />
      </figure>
        <div className={styles.index_box}>
          <div>
            <h2 className={styles.position}>
              {leftContentData.firstContentTitle}
            </h2>
            <p className={styles.text}>{leftContentData.firstHalf}</p>
          </div>
          {
            isSecondContent && (
            <div className={styles.secondContent}>
              <h2 className={styles.position}>
                  {leftContentData.secondContentTitle && leftContentData.secondContentTitle}
              </h2>
              <ul className={styles.text_list}>
                {leftContentData.secondHalf1 && <li>{leftContentData.secondHalf1}</li>}
                {leftContentData.secondHalf2 && <li>{leftContentData.secondHalf2}</li>}
                {leftContentData.secondHalf3 && <li>{leftContentData.secondHalf3}</li>}
              </ul>
            </div>
            )
          }
        </div>
        <figure className={styles.flex_img}>
          {leftContentData.imgCapture && (
              <img src={leftContentData.imgCapture} alt={leftContentData.alt} />
          )}
        </figure>
      </div>
    </div>
  )
}

export default LeftContents
